import React, { Component } from "react";
import Header from "../header";
import SelectedUserCar from "./SelectUserCar";
import { Link } from "react-router-dom";
class carSelectionRemainder extends Component {
  state = {
    changeDetail: true,
    handelPushHomePage: true,
  };
  backBtn = () => {
    this.props.history.goBack();
  };
  render() {
    return (
      <>
        <div className="carSelectionRemainder">
          {/* <div className='carSelectionHeader'>
            <div>
              <img
                src='/public/assets/icons/arrow-w.svg'
                alt='back'
                onClick={this.backBtn}
              />
              <span>انتخاب خودرو</span>
            </div>
          </div> */}
          <Header showSearchBar={true} title="انتخاب خودرو" backUrl="/" />
          <SelectedUserCar props={this.props} />
        </div>
      </>
    );
  }
}
export default carSelectionRemainder;
